import { AiImageResource } from 'dy-frontend-http-repository/lib/modules/AiImage/resources';
import domain from './domain';
import { resetAiImages } from './events';

// AI Image list`
export const $aiImages = domain.createStore<AiImageResource[]>([]).reset(resetAiImages);
